module.exports = __webpack_public_path__ + "static/00016.27342214.jpg";